import React from 'react';
import { MDBIcon } from 'mdb-react-ui-kit';
import { Link } from 'react-router-dom';

const PaymentFail = () => {
  return (
    <div className="text-center">
      <MDBIcon fas icon="times-circle" className="text-danger" size="4x" />
      <h2 className="mt-4">Payment Failed</h2>
      <Link to="/e-commerce/product-list" className="btn btn-primary mt-4">Back to Shopping</Link>
    </div>
  );
};

export default PaymentFail;